"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferResponse = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const enums_1 = require("../../enums");
const GetOfferResponseOffer_1 = require("./GetOfferResponseOffer");
class GetOfferResponse extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => GetOfferResponseOffer_1.GetOfferResponseOffer),
    (0, class_validator_1.ValidateNested)(),
    tslib_1.__metadata("design:type", GetOfferResponseOffer_1.GetOfferResponseOffer)
], GetOfferResponse.prototype, "offer", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.Channel)),
    (0, base_models_1.Docs)({
        example: enums_1.Channel.MIJN,
        description: 'Channel of the api key',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferResponse.prototype, "channel", void 0);
exports.GetOfferResponse = GetOfferResponse;
